import {
  DistributionRightsPublisherImage,
  PromoteYourBooksPublisherImage,
  PublishWithUsPublisherImage,
} from 'assets';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Card, { ICard } from '@/components/Partnership/Common/Card';
import Layout from '@/components/Partnership/Common/Card/Layout';
import Header from '@/components/Partnership/Common/Header';
interface Props {
  className?: string;
}
const ForPublishersSection: FC<Props> = ({ className }) => {
  const list: ICard[] = [
    {
      id: 1,
      title: 'List your Books on Oranges by Zebralearn',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: PromoteYourBooksPublisherImage,
      pointers: [
        'Increase visibility across ZebraLearn’s learner ecosystem',
        'Data-driven promotion for higher reach and engagement',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 2,
      title: 'Co-publish Together',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: PublishWithUsPublisherImage,
      pointers: [
        'Convert Your Existing Books to Visual-First',
        'Distribution to active learners',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
    {
      id: 3,
      title: 'Distribution Partnership',
      button: {
        link: 'https://form.jotform.com/260644797886074',
        text: 'Contact Us →',
      },
      image: DistributionRightsPublisherImage,
      pointers: [
        'Collaborate on Distribution',
        'Licensing & rights management support',
      ],
      tags: ['LINKEDIN', 'META', 'OTHERS'],
    },
  ];
  return (
    <div className={twMerge('', className)}>
      <Header title='For Publishers' className='md:pb-4 mb-[18px]' />
      <Layout>
        {list.map((i) => (
          <Card key={i.id} card={i} />
        ))}
      </Layout>
    </div>
  );
};

export default ForPublishersSection;
